import { render, staticRenderFns } from "./DraftAppIcon.vue?vue&type=template&id=e12524da"
import script from "./DraftAppIcon.vue?vue&type=script&lang=js"
export * from "./DraftAppIcon.vue?vue&type=script&lang=js"
import style0 from "./DraftAppIcon.vue?vue&type=style&index=0&id=e12524da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports